import React from "react";

/* eslint-disable max-len */
export default function FilterListIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={40} height={40} viewBox="0 0 40 40">
            <g transform="translate(2759 -4295)">
                <circle
                    cx={20}
                    cy={20}
                    r={20}
                    transform="translate(-2759 4295)"
                    fill="rgba(41,46,54,0)"
                />
                <g fill="#9c9c9c">
                    <path
                        d="M1591 154.7h-8.5a1.2 1.2 0 01-1.2-1.2 1.2 1.2 0 011.2-1.2h8.5a1.2 1.2 0 011.2 1.2 1.2 1.2 0 01-1.2 1.2zM1603 154.7h-5a1.2 1.2 0 01-1.2-1.2 1.2 1.2 0 011.2-1.2h5a1.2 1.2 0 011.2 1.2 1.2 1.2 0 01-1.2 1.2zM1585 164.7h-3.5a1.2 1.2 0 01-1.2-1.2 1.2 1.2 0 011.2-1.2h3.5a1.2 1.2 0 011.2 1.2 1.2 1.2 0 01-1.2 1.2zM1602.5 164.7h-9.5a1.2 1.2 0 01-1.2-1.2 1.2 1.2 0 011.2-1.2h9.5a1.2 1.2 0 011.2 1.2 1.2 1.2 0 01-1.2 1.2z"
                        transform="translate(-4331.5 4157)"
                    />
                    <path
                        d="M1594.5 150.6a1.9 1.9 0 101.9 1.9 1.9 1.9 0 00-1.9-1.9m0-2.6a4.5 4.5 0 11-4.5 4.5 4.5 4.5 0 014.5-4.5zM1589.5 161.6a1.9 1.9 0 101.9 1.9 1.9 1.9 0 00-1.9-1.9m0-2.6a4.5 4.5 0 11-4.5 4.5 4.5 4.5 0 014.5-4.5z"
                        opacity={0.99}
                        transform="translate(-4331.5 4157)"
                    />
                </g>
            </g>
        </svg>
    );
}
